export default "<template>\r\n  <v-parallax src=\"https://cdn.vuetifyjs.com/images/parallax/material.jpg\"></v-parallax>\r\n</template>\r\n";